import { useUser } from '@folklore/auth';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { useThemeClassName } from '../../contexts/ThemeContext';
import UserLetter from './UserLetter';

import styles from '../../../styles/partials/leader.module.scss';

const propTypes = {
    position: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    leader: PropTypes.shape({
        points: PropTypes.number,
        name: PropTypes.string,
    }),
    pointsAbbreviation: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    position: null,
    leader: null,
    pointsAbbreviation: 'points',
    className: null,
};

function Leader({ position, leader, pointsAbbreviation, className }) {
    const themeClassName = useThemeClassName(styles);
    const { name: userName = null } = useUser() || {};
    const { points = null, name = null } = leader || {};

    return leader !== null ? (
        <div
            className={classNames([
                styles.container,
                themeClassName,
                className,
                { [styles.self]: name === userName },
            ])}
        >
            {position !== null ? <div className={styles.position}>{position}</div> : null}
            <div className={styles.player}>
                <UserLetter className={styles.letter} user={leader} withName />
            </div>
            <div className={styles.points}>
                {points} {pointsAbbreviation}
            </div>
        </div>
    ) : null;
}

Leader.propTypes = propTypes;
Leader.defaultProps = defaultProps;

export default Leader;
